import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\CalculatorSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\OurWorksSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\app\\components\\WhySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\components\\FloatingContactBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\components\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Working\\Desktop\\slavstroy\\src\\components\\ui\\AppLogo.tsx");
